// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { cn } from '@/lib/utils'

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'muted'
type BadgeSize    = 'sm' | 'md'

const variants: Record<BadgeVariant, string> = {
  default: 'bg-sage-100 text-sage-800',
  success: 'bg-status-successBg border border-status-successBorder text-status-successText',
  warning: 'bg-status-warnBg border border-status-warnBorder text-status-warnText',
  error:   'bg-status-alertBg border border-status-alertBorder text-status-alertText',
  info:    'bg-status-infoBg text-status-infoText',
  muted:   'bg-sand-200 text-ink-3',
}

const sizes: Record<BadgeSize, string> = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
}

interface BadgeProps {
  children:  React.ReactNode
  variant?:  BadgeVariant
  size?:     BadgeSize
  className?: string
}

export function Badge({ children, variant = 'default', size = 'sm', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        variants[variant],
        sizes[size],
        className,
      )}
    >
      {children}
    </span>
  )
}
